export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_user_profile_menu-9652e2793a6e731f277a565322998daf.svg";